import React from 'react'
import { ListImageBox as OriginalListImageBox } from '@next-nx/shared-ui/organisms'
import { ListImageBoxSettings } from './ListImageBoxSettings'
import { withBlock } from '../withBlock'
import { withCraft } from '../withCraft'
import { useEditor } from '@craftjs/core'

export const defaultProps = {
  title: 'Titolo',
  imagePos: 'bottom',
  imageVariant: '',
  src: 'https://via.placeholder.com/287x215.png',
  image: '',
}

export const ListImageBox = withBlock(
  (props) => {
    const blockProps = {
      ...defaultProps,
      ...props.block,
    };

    const { 
      title,
      imagePos,
      imageVariant,
      src,
      image,
    } = blockProps

    const { children } = props
    
    const { enabled } = useEditor((state) => ({
      enabled: state.options.enabled,
    }));

    return (
      <div
        ref={(ref) => props.retRef(ref)}
        className={'block-list-image-box ' + props.className}
      >
        <OriginalListImageBox
          key={image ? image : src}
          item={{
            name: title,
            image: image ? image : src,
          }}
          imageVariant={imageVariant}
          imagePos={imagePos}
          editMode={enabled}
          children={children.props?.children || []}
        />
      </div>
    );
  },
  defaultProps
);

ListImageBox.craft = withCraft({
  name: 'ListImageBox',
  defaultProps: defaultProps,
  settings: ListImageBoxSettings,
});
